<template>
  <div class="content">
    <div class="left-nav">
      <el-menu
        :default-active="activeIndex"
        class="el-menu-vertical-demo"
        @select="handleSelect"
      >
        <el-menu-item index="2">
          <span class="left-nav-text">通知公告</span>
          <span class="left-nav-icon">></span>
        </el-menu-item>
        <el-menu-item index="3">
          <span class="left-nav-text">时政要闻</span>
          <span class="left-nav-icon">></span>
        </el-menu-item>
        <el-menu-item index="4">
          <span class="left-nav-text">工作动态</span>
          <span class="left-nav-icon">></span>
        </el-menu-item>
        <el-menu-item index="5">
          <span class="left-nav-text">党务公开</span>
          <span class="left-nav-icon">></span>
        </el-menu-item>
        <el-menu-item index="6">
          <span class="left-nav-text">行风建设</span>
          <span class="left-nav-icon">></span>
        </el-menu-item>
        <el-menu-item index="7">
          <span class="left-nav-text">业务流程</span>
          <span class="left-nav-icon">></span>
        </el-menu-item>
        <el-menu-item index="8">
          <span class="left-nav-text">政策法规</span>
          <span class="left-nav-icon">></span>
        </el-menu-item>
        <el-menu-item index="9">
          <span class="left-nav-text">缴存</span>
          <span class="left-nav-icon">></span>
        </el-menu-item>
        <el-menu-item index="10">
          <span class="left-nav-text">提取</span>
          <span class="left-nav-icon">></span>
        </el-menu-item>
        <el-menu-item index="11">
          <span class="left-nav-text">贷款</span>
          <span class="left-nav-icon">></span>
        </el-menu-item>
        <el-menu-item index="12">
          <span class="left-nav-text">网点分布</span>
          <span class="left-nav-icon">></span>
        </el-menu-item>
        <el-menu-item index="13">
          <span class="left-nav-text">行政执法公示</span>
          <span class="left-nav-icon">></span>
        </el-menu-item>
        <el-menu-item index="14">
          <span class="left-nav-text">预算决算公开栏</span>
          <span class="left-nav-icon">></span>
        </el-menu-item>
        <el-menu-item index="1">
          <span class="left-nav-text">表格下载</span>
          <span class="left-nav-icon">></span>
        </el-menu-item>
      </el-menu>
    </div>
    <div class="right-list">
      <!-- 表格下载 -->
      <div v-show="activeIndex == 1">
        <div class="list" v-loading="loading_84">
          <ul>
            <li v-for="item in bgxzList" @click="tonews(84, item.id)">
              <span class="text">{{ item.title | ellipsis(50) }}</span>
              <span class="time"
                >[{{ item.releaseDate | formatTime("YYYY-MM-DD") }}]</span
              >
            </li>
          </ul>
          <el-pagination
            v-show="bgxztotal != 0"
            background
            layout="total,prev, pager, next"
            @current-change="handleCurrentChange1($event, '10', '84')"
            :total="bgxztotal"
          >
          </el-pagination>
        </div>
      </div>
      <!-- 通知公告 -->
      <div v-show="activeIndex == 2">
        <div class="list" v-loading="loading_78">
          <ul>
            <li v-for="item in tzggList" @click="tonews(78, item.id)">
              <span class="text">{{ item.title | ellipsis(50) }}</span>
              <span class="time"
                >[{{ item.releaseDate | formatTime("YYYY-MM-DD") }}]</span
              >
            </li>
          </ul>
          <el-pagination
            v-show="tzggtotal != 0"
            background
            layout="total,prev, pager, next"
            @current-change="handleCurrentChange1($event, '10', '78')"
            :total="tzggtotal"
          >
          </el-pagination>
        </div>
      </div>
      <!-- 时政要闻 -->
      <div v-show="activeIndex == 3">
        <div class="list" v-loading="loading_83">
          <ul>
            <li v-for="item in szywList" @click="tonews(83, item.id)">
              <span class="text">{{ item.title | ellipsis(50) }}</span>
              <span class="time"
                >[{{ item.releaseDate | formatTime("YYYY-MM-DD") }}]</span
              >
            </li>
          </ul>
          <el-pagination
            v-show="szywtotal != 0"
            background
            layout="total,prev, pager, next"
            @current-change="handleCurrentChange1($event, '10', '83')"
            :total="szywtotal"
          >
          </el-pagination>
        </div>
      </div>

      <!-- 工作动态 -->
      <div v-show="activeIndex == 4">
        <div class="list" v-loading="loading_79">
          <ul>
            <li v-for="item in gzdtList" @click="tonews(79, item.id)">
              <span class="text">{{ item.title | ellipsis(50) }}</span>
              <span class="time"
                >[{{ item.releaseDate | formatTime("YYYY-MM-DD") }}]</span
              >
            </li>
          </ul>
          <el-pagination
            v-show="gzdttotal != 0"
            background
            layout="total,prev, pager, next"
            @current-change="handleCurrentChange1($event, '10', '79')"
            :total="gzdttotal"
          >
          </el-pagination>
        </div>
      </div>
      <!-- 党务公开 -->
      <div v-show="activeIndex == 5">
        <div class="list" v-loading="loading_82">
          <ul>
            <li v-for="item in dwgkList" @click="tonews(82, item.id)">
              <span class="text">{{ item.title | ellipsis(50) }}</span>
              <span class="time"
                >[{{ item.releaseDate | formatTime("YYYY-MM-DD") }}]</span
              >
            </li>
          </ul>
          <el-pagination
            v-show="dwgktotal != 0"
            background
            layout="total,prev, pager, next"
            @current-change="handleCurrentChange1($event, '10', '82')"
            :total="dwgktotal"
          >
          </el-pagination>
        </div>
      </div>
      <!-- 行风建设 -->
      <div v-show="activeIndex == 6">
        <div class="list" v-loading="loading_81">
          <ul>
            <li v-for="item in xfjsList" @click="tonews(81, item.id)">
              <span class="text">{{ item.title | ellipsis(50) }}</span>
              <span class="time"
                >[{{ item.releaseDate | formatTime("YYYY-MM-DD") }}]</span
              >
            </li>
          </ul>
          <el-pagination
            v-show="xfjstotal != 0"
            background
            layout="total,prev, pager, next"
            @current-change="handleCurrentChange1($event, '10', '81')"
            :total="xfjstotal"
          >
          </el-pagination>
        </div>
      </div>
      <!-- 业务流程 -->
      <div v-show="activeIndex == 7">
        <div class="list" v-loading="loading_87">
          <ul>
            <li v-for="item in ywlcList" @click="tonews(87, item.id)">
              <span class="text">{{ item.title | ellipsis(50) }}</span>
              <span class="time"
                >[{{ item.releaseDate | formatTime("YYYY-MM-DD") }}]</span
              >
            </li>
          </ul>
          <el-pagination
            v-show="ywlctotal != 0"
            background
            layout="total,prev, pager, next"
            @current-change="handleCurrentChange1($event, '10', '87')"
            :total="ywlctotal"
          >
          </el-pagination>
        </div>
      </div>
      <!-- 政策法规 -->
      <div v-show="activeIndex == 8">
        <div class="list" v-loading="loading_80">
          <ul>
            <li v-for="item in zcfgList" @click="tonews(80, item.id)">
              <span class="text">{{ item.title | ellipsis(50) }}</span>
              <span class="time"
                >[{{ item.releaseDate | formatTime("YYYY-MM-DD") }}]</span
              >
            </li>
          </ul>
          <el-pagination
            v-show="zcfgtotal != 0"
            background
            layout="total,prev, pager, next"
            @current-change="handleCurrentChange1($event, '10', '80')"
            :total="zcfgtotal"
          >
          </el-pagination>
        </div>
      </div>
      <!-- 缴存 -->
      <div v-show="activeIndex == 9">
        <div class="list" v-loading="loading_99">
          <ul>
            <li v-for="item in jcList" @click="tonews(99, item.id)">
              <span class="text">{{ item.title | ellipsis(50) }}</span>
              <span class="time"
                >[{{ item.releaseDate | formatTime("YYYY-MM-DD") }}]</span
              >
            </li>
          </ul>
          <el-pagination
            v-show="jctotal != 0"
            background
            layout="total,prev, pager, next"
            @current-change="handleCurrentChange1($event, '10', '99')"
            :total="jctotal"
          >
          </el-pagination>
        </div>
      </div>
      <!-- 支取 -->
      <div v-show="activeIndex == 10">
        <div class="list" v-loading="loading_100">
          <ul>
            <li v-for="item in zqList" @click="tonews(100, item.id)">
              <span class="text">{{ item.title | ellipsis(50) }}</span>
              <span class="time"
                >[{{ item.releaseDate | formatTime("YYYY-MM-DD") }}]</span
              >
            </li>
          </ul>
          <el-pagination
            v-show="zqtotal != 0"
            background
            layout="total,prev, pager, next"
            @current-change="handleCurrentChange1($event, '10', '100')"
            :total="zqtotal"
          >
          </el-pagination>
        </div>
      </div>
      <!-- 贷款 -->
      <div v-show="activeIndex == 11">
        <div class="list" v-loading="loading_101">
          <ul>
            <li v-for="item in dkList" @click="tonews(101, item.id)">
              <span class="text">{{ item.title | ellipsis(50) }}</span>
              <span class="time"
                >[{{ item.releaseDate | formatTime("YYYY-MM-DD") }}]</span
              >
            </li>
          </ul>
          <el-pagination
            v-show="dktotal != 0"
            background
            layout="total,prev, pager, next"
            @current-change="handleCurrentChange1($event, '10', '101')"
            :total="dktotal"
          >
          </el-pagination>
        </div>
      </div>
      <!-- 网点分布 -->
      <div v-show="activeIndex == 12" v-loading="wdfb">
        <!-- <el-collapse v-model="wdfbactiveName" accordion >
				  <el-collapse-item :title="item.list[0].info" :name="key" v-for="(item,key) in wdfb">
				    <div>{{item.content[0].title}}:{{item.content[0].info}}</div>
				    <div>{{item.content[1].title}}:{{item.content[1].info}}</div>
					<div>{{item.content[2].title}}:{{item.content[2].info}}</div>
					<div>{{item.content[3].title}}:{{item.content[3].info}}</div>
				  </el-collapse-item>
				</el-collapse> -->
        <el-table :data="wdfbdata" border style="width: 100%">
          <el-table-column type="index" label="序号" width="50">
          </el-table-column>
          <el-table-column prop="wdmc" label="网点名称" width="180">
          </el-table-column>
          <el-table-column prop="wddz" label="网点地址" width="380">
          </el-table-column>
          <el-table-column prop="wddh" label="网点电话"> </el-table-column>
        </el-table>
      </div>
      <!-- 行政执法公示 -->
      <div v-show="activeIndex == 13">
        <el-tabs v-model="xzzfgsactiveName" type="card">
          <el-tab-pane
            label="事前公示"
            name="sqgs"
            v-loading="loading_102"
            class="list"
          >
            <ul>
              <li v-for="item in sqgsList" @click="tonews(102, item.id)">
                <span class="text">{{ item.title | ellipsis(50) }}</span>
                <span class="time"
                  >[{{ item.releaseDate | formatTime("YYYY-MM-DD") }}]</span
                >
              </li>
            </ul>
            <el-pagination
              v-show="sqgstotal != 0"
              background
              layout="total,prev, pager, next"
              @current-change="handleCurrentChange1($event, '10', '102')"
              :total="sqgstotal"
            >
            </el-pagination>
          </el-tab-pane>
          <el-tab-pane
            label="事后公示"
            name="shgs"
            v-loading="loading_103"
            class="list"
          >
            <ul>
              <li v-for="item in shgsList" @click="tonews(103, item.id)">
                <span class="text">{{ item.title | ellipsis(50) }}</span>
                <span class="time"
                  >[{{ item.releaseDate | formatTime("YYYY-MM-DD") }}]</span
                >
              </li>
            </ul>
            <el-pagination
              v-show="shgstotal != 0"
              background
              layout="total,prev, pager, next"
              @current-change="handleCurrentChange1($event, '10', '103')"
              :total="shgstotal"
            >
            </el-pagination>
          </el-tab-pane>
        </el-tabs>
      </div>
      <!-- 预算决算公开栏 -->
      <div v-show="activeIndex == 14">
        <el-tabs v-model="xysjsgklactiveName" type="card">
          <el-tab-pane
            label="部门预算"
            name="bmys"
            v-loading="loading_104"
            class="list"
          >
            <ul>
              <li v-for="item in bmysList" @click="tonews(104, item.id)">
                <span class="text">{{ item.title | ellipsis(50) }}</span>
                <span class="time"
                  >[{{ item.releaseDate | formatTime("YYYY-MM-DD") }}]</span
                >
              </li>
            </ul>
            <el-pagination
              background
              layout="total,prev, pager, next"
              @current-change="handleCurrentChange1($event, '10', '104')"
              :total="bmystotal"
            >
            </el-pagination>
          </el-tab-pane>
          <el-tab-pane
            label="部门决算"
            name="bmjs"
            v-loading="loading_105"
            class="list"
          >
            <ul>
              <li v-for="item in bmjsList" @click="tonews(105, item.id)">
                <span class="text">{{ item.title | ellipsis(50) }}</span>
                <span class="time"
                  >[{{ item.releaseDate | formatTime("YYYY-MM-DD") }}]</span
                >
              </li>
            </ul>
            <el-pagination
              background
              layout="total,prev, pager, next"
              @current-change="handleCurrentChange1($event, '10', '105')"
              :total="bmjstotal"
            >
            </el-pagination>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios"
import qs from "qs"
export default {
  data() {
    return {
      activeIndex: "1",
      bgxzList: [],
      bgxztotal: 0,
      loading_84: true,
      tzggList: [],
      tzggtotal: 0,
      loading_78: true,
      szywList: [],
      szywtotal: 0,
      loading_83: true,

      jgjjList: [],
      jgjjtotal: 0,
      loading_171: true,

      fwqdList: [],
      fwqdtotal: 0,
      loading_76: true,

      gzdtList: [],
      gzdttotal: 0,
      loading_79: true,
      dwgkList: [],
      dwgktotal: 0,
      loading_82: true,
      xfjsList: [],
      xfjstotal: 0,
      loading_81: true,
      ywlcList: [],
      ywlctotal: 0,
      loading_87: true,
      zcfgList: [],
      zcfgtotal: 0,
      loading_80: true,
      jcList: [],
      jctotal: 0,
      loading_99: true,
      zqList: [],
      zqtotal: 0,
      loading_100: true,
      dkList: [],
      dktotal: 0,
      loading_101: true,
      wdfb: true,
      wdfbdata: [],
      wdfbactiveName: 0,
      xzzfgsactiveName: "sqgs",
      sqgsList: [],
      sqgstotal: 0,
      loading_102: true,
      shgsList: [],
      shgstotal: 0,
      loading_103: true,
      xysjsgklactiveName: "bmys",
      bmysList: [],
      bmystotal: 0,
      loading_104: true,
      bmjsList: [],
      bmjstotal: 0,
      loading_105: true,
    }
  },
  filters: {
    //限制文本显示字数,超出部分用...代替
    ellipsis(value, index) {
      if (!value) return ""
      if (value.length > index) {
        return value.slice(0, index) + "..." //0:下标,从第一个字开始显示,50:显示字数,多余用...代替
      }
      return value
    },
    formatTime(value, format = "YYYY-MM-DD") {
      if (!value) return ""
      const date = new Date(value)
      const options = {
        "Y+": date.getFullYear().toString(), // 年
        "M+": (date.getMonth() + 1).toString(), // 月
        "D+": date.getDate().toString(), // 日
        "H+": date.getHours().toString(), // 时
        "m+": date.getMinutes().toString(), // 分
        "S+": date.getSeconds().toString(), // 秒
        // 可以继续添加其他格式化选项
      }
      for (let k in options) {
        const reg = new RegExp(`(${k})`)
        if (reg.test(format)) {
          format = format.replace(
            reg,
            options[k].length === 1 ? `0${options[k]}` : `${options[k]}`
          )
        }
      }
      return format
    },
  },
  watch: {
    "$route.query.activeIndex": function(newValue, oldValue) {
      this.activeIndex = newValue
    },
  },
  created() {
    if (
      this.$route.query.activeIndex < 15 &&
      this.$route.query.activeIndex > 0
    ) {
      this.activeIndex = this.$route.query.activeIndex
    }
    // 表格下载
    this.getNewList("0", "10", "84")
    // 获取时政要闻列表
    this.getNewList("0", "10", "83")
    // 获取通知公告列表
    this.getNewList("0", "10", "78")

    // 获取工作动态列表
    // this.getList("0", "5204", "06")
    this.getNewList("0", "10", "79")

    // 获取党务公开列表
    // this.getList("0", "5526", "05")
    this.getNewList("0", "10", "82")

    // 获取行风建设列表
    // this.getList("0", "5528", "04")
    this.getNewList("0", "10", "81")

    // 获取业务流程列表
    // this.getList("0", "5201", "10")
    this.getNewList("0", "10", "87")

    // 获取政策法规列表
    // this.getList("0", "5522", "03")
    this.getNewList("0", "10", "80")

    // 获取缴存列表
    // this.getList("0", "5600", "14")
    this.getNewList("0", "10", "99")

    // 获取支取列表
    // this.getList("0", "5600", "15")
    this.getNewList("0", "10", "100")

    // 获取贷款列表
    // this.getList("0", "5600", "16")
    this.getNewList("0", "10", "101")

    // 获取网点分布
    this.getwdfbList()

    // 行政执法公示-事前公示
    // this.getList("0", "5600", "18")
    this.getNewList("0", "10", "102")

    // 行政执法公示-事后公示
    // this.getList("0", "5600", "19")
    this.getNewList("0", "10", "103")

    // 预算决算公开栏-部门预算
    // this.getList("0", "5600", "30")
    this.getNewList("0", "10", "104")

    // 预算决算公开栏-部门决算
    // this.getList("0", "5600", "31")
    this.getNewList("0", "10", "105")
  },
  methods: {
    handleSelect(index) {
      if (this.$route.query.activeIndex !== index) {
        this.$router.push({ path: "/list?activeIndex=" + index })
      }
    },
    getNewList(first, count, channelIds) {
      let data = {}
      data.first = first
      data.count = count
      data.channelIds = channelIds
      axios
        .post("/api/gateway/03180/09/web/110418", qs.stringify(data))
        .then((response) => {
          //   this.loading_tzgg = false
          //   this.tzggList = response.data.body
          switch (channelIds) {
            // 表格下载
            case "84":
              this.loading_84 = false
              this.bgxzList = response.data.body
              this.bgxztotal = response.data.totalSize
              break
            // 通知公告
            case "78":
              this.loading_78 = false
              this.tzggList = response.data.body
              this.tzggtotal = response.data.totalSize
              break
            // 时政要闻
            case "83":
              this.loading_83 = false
              this.szywList = response.data.body
              this.szywtotal = response.data.totalSize
              break
            // 党务公开
            case "82":
              this.loading_82 = false
              this.dwgkList = response.data.body
              this.dwgktotal = response.data.totalSize
              break
            // 行风建设
            case "81":
              this.loading_81 = false
              this.xfjsList = response.data.body
              this.xfjstotal = response.data.totalSize
              break
            // 业务流程
            case "87":
              this.loading_87 = false
              this.ywlcList = response.data.body
              this.ywlctotal = response.data.totalSize
              break
            // 政策法规
            case "80":
              this.loading_80 = false
              this.zcfgList = response.data.body
              this.zcfgtotal = response.data.totalSize
              break
            // 缴存
            case "99":
              this.loading_99 = false
              this.jcList = response.data.body
              this.jctotal = response.data.totalSize
              break
            // 支取
            case "100":
              this.loading_100 = false
              this.zqList = response.data.body
              this.zqtotal = response.data.totalSize
              break
            // 贷款
            case "101":
              this.loading_101 = false
              this.dkList = response.data.body
              this.dktotal = response.data.totalSize
              break
            // 行政执法公示-事前公示
            case "102":
              this.loading_102 = false
              this.sqgsList = response.data.body
              this.sqgstotal = response.data.totalSize
              break
            // 行政执法公示-事后公示
            case "103":
              this.loading_103 = false
              this.shgsList = response.data.body
              this.shgstotal = response.data.totalSize
              break
            // 预算决算公开栏-部门预算
            case "104":
              this.loading_104 = false
              this.bmysList = response.data.body
              this.bmystotal = response.data.totalSize
              break
            // 预算决算公开栏-部门决算
            case "105":
              this.loading_105 = false
              this.bmjsList = response.data.body
              this.bmjstotal = response.data.totalSize
              break
            // 工作动态
            case "79":
              this.loading_79 = false
              this.gzdtList = response.data.body
              this.gzdttotal = response.data.totalSize
          }
        })
    },
    getList(pagenum, buzType, parentViewItemId) {
      axios
        .post(
          "/token/admin/huaxin/index",
          qs.stringify({
            data: {
              buzType: buzType,
              keyword: "",
              parentViewItemId: parentViewItemId,
              pagenum: pagenum,
              pagerows: "10",
            },
            url: "appapi70009.json",
          })
        )
        .then((response) => {
          switch ((buzType, parentViewItemId)) {
            // 表格下载
            case ("5529", "07"):
              this.loading_84 = false
              this.bgxzList = response.data.result.news.newsList
              this.bgxztotal = response.data.result.news.total
              break
            // 通知公告
            case ("5521", "01"):
              this.loading_78 = false
              this.tzggList = response.data.result.news.newsList
              this.tzggtotal = response.data.result.news.total
              break
            // 时政要闻
            case ("5204", "06"):
              this.loading_83 = false
              this.szywList = response.data.result.news.newsList
              this.szywtotal = response.data.result.news.total
              break
            // 工作动态
            case ("5535", "02"):
              this.loading_79 = false
              this.gzdtList = response.data.result.news.newsList
              this.gzdttotal = response.data.result.news.total
              break
            // 党务公开
            case ("5526", "05"):
              this.loading_82 = false
              this.dwgkList = response.data.result.news.newsList
              this.dwgktotal = response.data.result.news.total
              break
            // 行风建设
            case ("5528", "04"):
              this.loading_81 = false
              this.xfjsList = response.data.result.news.newsList
              this.xfjstotal = response.data.result.news.total
              break
            // 业务流程
            case ("5201", "10"):
              this.loading_87 = false
              this.ywlcList = response.data.result.news.newsList
              this.ywlctotal = response.data.result.news.total
              break
            // 政策法规
            case ("5522", "03"):
              this.loading_80 = false
              this.zcfgList = response.data.result.news.newsList
              this.zcfgtotal = response.data.result.news.total
              break
            // 缴存
            case ("5600", "14"):
              this.loading_99 = false
              this.jcList = response.data.result.news.newsList
              this.jctotal = response.data.result.news.total
              break
            // 支取
            case ("5600", "15"):
              this.loading_100 = false
              this.zqList = response.data.result.news.newsList
              this.zqtotal = response.data.result.news.total
              break
            // 贷款
            case ("5600", "16"):
              this.loading_101 = false
              this.dkList = response.data.result.news.newsList
              this.dktotal = response.data.result.news.total
              break
            // 行政执法公示-事前公示
            case ("5600", "18"):
              this.loading_102 = false
              this.sqgsList = response.data.result.news.newsList
              this.sqgstotal = response.data.result.news.total
              break
            // 行政执法公示-事后公示
            case ("5600", "19"):
              this.loading_103 = false
              this.shgsList = response.data.result.news.newsList
              this.shgstotal = response.data.result.news.total
              break
            // 预算决算公开栏-部门预算
            case ("5600", "30"):
              this.loading_104 = false
              this.bmysList = response.data.result.news.newsList
              this.bmystotal = response.data.result.news.total
              break
            // 预算决算公开栏-部门决算
            case ("5600", "31"):
              this.loading_105 = false
              this.bmjsList = response.data.result.news.newsList
              this.bmjstotal = response.data.result.news.total
              break
          }
        })
        .catch(function(error) {
          // if(buzType =="5529"){
          //  alert("综服接口请求超时，请联系客服人员进行反馈。")
          // }
          console.log(error)
        })
    },
    getwdfbList() {
      axios
        .post(
          "/token/admin/huaxin/index",
          qs.stringify({
            data: { buzType: "5101", selectType: "2", selectValue: "" },
            url: "appapi10101.json",
          })
        )
        .then((response) => {
          for (let i = 0; i < response.data.result.length; i++) {
            this.wdfb = false
            const data = {
              wdmc: response.data.result[i].list[0].info,
              wddz: response.data.result[i].content[3].info.replace(
                "map://",
                ""
              ),
              wddh: response.data.result[i].content[1].info.replace(
                "tel://",
                ""
              ),
            }
            this.wdfbdata.push(data)
          }
        })
        .catch(function(error) {
          // 请求失败处理
          console.log(error)
        })
    },
    tonews(channelIds, id) {
      this.$router.push({
        path: "/new_details",
        query: { channelIds: channelIds, id: id },
      })
    },
    handleCurrentChange(buzType, pagenum, parentViewItemId) {
      this.$set(this, "loading_" + buzType + "_" + parentViewItemId, true)
      this.getList(pagenum - 1, buzType, parentViewItemId)
    },

    handleCurrentChange1(first, count, channelIds) {
      this.$set(this, "loading_" + channelIds, true)
      this.getNewList((first - 1) * 10, count, channelIds)
    },
  },
}
</script>

<style scoped>
.content {
  display: flex;
  background-color: #ffffff;
}
.left-nav {
  width: 250px;
  min-height: 800px;
  background-color: #ffffff;
}
.right-list {
  width: 930px;
  min-height: 800px;
  margin: 0 20px;
}
.right-list li {
  height: 32px;
  line-height: 32px;
  text-align: left;
  list-style-type: none;
  border-bottom: 1px dashed #999;
}
.right-list li .text:hover {
  cursor: pointer;
  color: red;
}
.right-list .time {
  float: right;
  margin-right: 4px;
  font-size: 12px;
  color: #999;
}
.list {
  min-height: 400px;
}

.el-menu-vertical-demo span {
  margin-left: 10px;
}
.el-menu-item {
  font-size: 18px;
  margin: 0 10px;
  border-bottom: 1px solid #c8c8c8;
}
.left-nav-icon {
  float: right;
}
.el-pagination {
  text-align: right;
}
</style>
